import React from 'react'
import { Checkbox } from '@/components_deprecated'
import { FilterPopup } from '@/components_deprecated/FilterPopup'
import { StyledScrollBar } from '@/components_deprecated/FilterPopup/components'

interface FilterField<T = any> {
  key: string
  label: string
  type: 'boolean' | 'multiSelect' | 'singleSelect'
  values?: T[]
  value?: T | T[] | boolean
  onChange: (value: T | T[] | boolean) => void
}

interface GenericFilterProps {
  fields: FilterField[]
}

const GenericFilter: React.FC<GenericFilterProps> = ({ fields }) => {
  const labelStyle = (key: string) =>
    key
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, str => str.toUpperCase())
      .replace(/_/g, ' ')

  return (
    <FilterPopup>
      {fields.map(field => (
        <div key={field.key} style={{ marginBottom: '1rem' }}>
          <h4>{field.label}</h4>
          {field.type === 'multiSelect' &&
            field.values &&
            Array.isArray(field.value) && (
              <StyledScrollBar
                style={{
                  maxHeight: '200px',
                }}
                options={{
                  suppressScrollY: field.values.length < 6,
                }}
              >
                {field.values.map(val => (
                  <Checkbox
                    key={val}
                    label={labelStyle(String(val))}
                    checked={field.value.includes(val)}
                    onChange={() => {
                      const newValue = field.value.includes(val)
                        ? field.value.filter((v: any) => v !== val)
                        : [...field.value, val]
                      field.onChange(newValue)
                    }}
                    boxWidth="32px"
                    boxHeight="32px"
                    fontSize="1rem"
                  />
                ))}
              </StyledScrollBar>
            )}

          {field.type === 'singleSelect' && field.values && (
            <select
              value={String(field.value ?? '')}
              onChange={e => field.onChange(e.target.value)}
            >
              {field.values.map(val => (
                <option key={val} value={String(val)}>
                  {val}
                </option>
              ))}
            </select>
          )}
        </div>
      ))}
    </FilterPopup>
  )
}

export default GenericFilter
